export const keys = {
  user: ['user'] as const,
  memberships: () => [...keys.user, 'memberships'] as const,
  preferences: () => [...keys.user, 'preferences'] as const,
  members: () => [...keys.user, 'members'] as const,
} as const;
